export default __webpack_public_path__ + "static/pink_arrow-96e3c1b62d152f3109eee0db5e2dc981.svg";